module.exports = __webpack_public_path__ + "media/images/goll.logo-b63ab0b36fbb8345919bc6cd17e9540a.svg";